import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'CompanyConfigurationController',
            CompanyConfigurationController
        );

    function CompanyConfigurationController(CompanyFactory, CompaniesFactory) {
        var vm = this;

        init();

        function init() {
            getCurrentCompany();
        }

        function getCurrentCompany() {
            CompanyFactory.readCompany().then(function (company) {
                CompaniesFactory.readCompanies(company.data.organization.party_uuid).then(
                    function (response) {
                        vm.subdomain = response.data.subdomain_name;
                    }
                );
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/company_configuration/company-configuration.controller.ts